const PageBody = ({children}) => (
  <div className="relative bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto w-full p-10">{children}</div>
  </div>
);

export default PageBody;
